'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    theme = Object.assign({}, theme, {
        color: theme.idleColor,
        placeholder: theme.idlePlaceholder,
        labelColor: theme.idleLabelColor,
        borderColor: theme.idleBorderColor,
        borderStyle: theme.idleBorderStyle,
        borderWidth: theme.idleBorderWidth,
        borderTransform: theme.idleBorderTransform,
        borderRadius: theme.idleBorderRadius,
        background: theme.idleBackground,
        boxShadow: theme.idleBoxShadow,
        outline: theme.idleOutline
    });

    if (this.state.hover) {
        theme = Object.assign({}, theme, {
            color: theme.hoverColor,
            placeholder: theme.hoverPlaceholder,
            labelColor: theme.hoverLabelColor,
            borderColor: theme.hoverBorderColor,
            borderStyle: theme.hoverBorderStyle,
            borderWidth: theme.hoverBorderWidth,
            borderTransform: theme.hoverBorderTransform,
            borderRadius: theme.hoverBorderRadius,
            background: theme.hoverBackground,
            boxShadow: theme.hoverBoxShadow,
            outline: theme.hoverOutline
        });
    }

    if (this.state.focus) {
        theme = Object.assign({}, theme, {
            color: theme.focusColor,
            placeholder: theme.focusPlaceholder,
            labelColor: this.props.error ? theme.errorLabelColor : theme.focusLabelColor,
            borderColor: theme.focusBorderColor,
            borderStyle: theme.focusBorderStyle,
            borderWidth: theme.focusBorderWidth,
            borderTransform: theme.focusBorderTransform,
            borderRadius: theme.focusBorderRadius,
            background: theme.focusBackground,
            boxShadow: theme.focusBoxShadow,
            outline: theme.focusOutline
        });
    }

    if (this.props.error) {
        theme = Object.assign({}, theme, {
            color: theme.errorColor,
            placeholder: theme.errorPlaceholder,
            borderColor: theme.errorBorderColor,
            borderStyle: theme.errorBorderStyle,
            borderWidth: theme.errorBorderWidth,
            borderTransform: theme.errorBorderTransform,
            borderRadius: theme.errorBorderRadius,
            background: theme.errorBackground,
            boxShadow: theme.errorBoxShadow,
            outline: theme.errorOutline
        });
    }

    if (this.props.disabled) {
        theme = Object.assign({}, theme, {
            color: theme.disabledColor,
            placeholder: theme.disabledPlaceholder,
            labelColor: theme.disabledLabelColor,
            borderStyle: theme.disabledBorderStyle,
            borderColor: theme.disabledBorderColor,
            borderWidth: theme.disabledBorderWidth,
            borderTransform: theme.disabledBorderTransform,
            borderRadius: theme.disabledBorderRadius,
            background: theme.disabledBackground,
            boxShadow: theme.disabledBoxShadow,
            outline: theme.disabledOutline
        });
    }

    // label is not floats
    if (!this.props.floating || this.state.focus || !!this.props.value || !!this.props.defaultValue) {
        theme.labelTransform = 'scale(1) translate3d(0px, 0px, 0px)';
        // label floats and increase size relative to lineHeight
    } else {
        var baseHeight = (0, _pixelToNumber2.default)(theme.labelLineHeight),
            relativeHeight = (0, _pixelToNumber2.default)(theme.fontSize) * 1.5,
            paddingTop = (0, _pixelToNumber2.default)(theme.paddingTop);

        theme.labelTransform = 'translateY(' + (baseHeight + paddingTop) + 'px) scale(' + relativeHeight / baseHeight + ')';
        theme.labelPaddingLeft = theme.paddingLeft;
        theme.labelPaddingRight = theme.paddingRight;
        theme.labelOverflow = 'hidden';
    }

    // рамка со всех сторон, классический инпут
    // скрываем нижнюю границу, применяем стиль к инпуту напрямую
    var wrappedBorder = !/none/.test(theme.borderStyle),
        passiveBorderOpacity = wrappedBorder || this.props.disabled ? 0 : 1,
        activeBorderOpacity = wrappedBorder ? 0 : 1,
        fieldBorder = {};

    if (wrappedBorder) {
        fieldBorder = {
            borderStyle: theme.borderStyle,
            borderColor: theme.borderColor,
            borderWidth: theme.borderWidth,
            borderRadius: theme.borderRadius
        };
    }

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            position: 'relative',
            display: theme.display,
            width: theme.width,
            minWidth: theme.minWidth,
            boxSizing: theme.boxSizing
        },
        field: Object.assign({
            fontSize: theme.fontSize,
            lineHeight: theme.lineHeight,
            fontFamily: theme.fontFamily,
            paddingTop: theme.paddingTop,
            paddingRight: theme.paddingRight,
            paddingBottom: theme.paddingBottom,
            paddingLeft: theme.paddingLeft,
            background: theme.background,
            boxShadow: theme.boxShadow,
            outline: theme.outline,
            width: '100%',
            margin: 0,
            position: 'relative',
            color: theme.color,
            border: '0 none',
            transitionDuration: theme.transitionDuration,
            transitionFunction: theme.transitionFunction,
            transitionProperty: 'color, border, boxShadow, background',
            boxSizing: 'border-box',
            textAlign: theme.textAlign
        }, fieldBorder, {

            '&::placeholder': {
                color: theme.placeholder,
                transitionDuration: theme.transitionDuration,
                transitionFunction: theme.transitionFunction,
                transitionProperty: 'color'
            },

            '&:focus': {
                outline: '0 none'
            }
        }),
        label: {
            color: theme.labelColor,
            fontSize: theme.labelFontSize,
            lineHeight: theme.labelLineHeight,
            fontFamily: theme.fontFamily,
            position: 'absolute',
            top: 0,
            left: 0,
            transitionDuration: theme.transitionDuration,
            transitionFunction: theme.transitionFunction,
            transitionProperty: 'color, transform',
            transform: theme.labelTransform,
            transformOrigin: '0% 0%',
            textWrap: 'none',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            width: '100%',
            overflow: theme.labelOverflow,
            textAlign: theme.textAlign,
            paddingTop: '0',
            paddingRight: theme.labelPaddingRight,
            paddingBottom: '0',
            paddingLeft: theme.labelPaddingLeft
        },
        labelHolder: {
            fontSize: theme.labelFontSize,
            lineHeight: theme.labelLineHeight
        },
        border: {
            borderImage: 'none',
            borderStyle: 'none none solid',
            boxSizing: 'content-box',
            height: 0,
            margin: 0,
            width: '100%',
            position: 'absolute',
            bottom: 0,
            borderColor: theme.idleBorderColor,
            borderWidth: 'medium medium ' + theme.idleBorderWidth,
            opacity: passiveBorderOpacity
        },
        activeBorder: {
            borderImage: 'none',
            borderStyle: theme.borderStyle,
            boxSizing: 'content-box',
            height: 0,
            margin: 0,
            transitionDuration: theme.transitionDuration,
            transitionFunction: theme.transitionFunction,
            transitionProperty: 'opacity, transform, border',
            width: '100%',
            position: 'absolute',
            bottom: 0,
            borderWidth: 'medium medium ' + theme.borderWidth,
            borderColor: theme.borderColor,
            transform: theme.borderTransform,
            opacity: activeBorderOpacity
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        field: (0, _aphroditeJss.css)(styleList.field),
        label: (0, _aphroditeJss.css)(styleList.label),
        labelHolder: (0, _aphroditeJss.css)(styleList.labelHolder),
        border: (0, _aphroditeJss.css)(styleList.border),
        activeBorder: (0, _aphroditeJss.css)(styleList.activeBorder)
    };
};

var _pixelToNumber = require('../../style/pixelToNumber');

var _pixelToNumber2 = _interopRequireDefault(_pixelToNumber);

var _aphroditeJss = require('aphrodite-jss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseTheme = function baseTheme(theme) {
    return {
        display: 'inline-block',
        fontSize: theme.tsNormal,
        fontWeight: theme.twNormal,
        lineHeight: 1.5,
        fontFamily: theme.fontFamily,
        paddingTop: theme.gutter + 'px',
        paddingRight: '0',
        paddingLeft: '0',
        paddingBottom: theme.gutter + 'px',
        textAlign: 'left',
        boxSizing: 'border-box',
        width: 'auto',
        minWidth: 'auto',

        labelFontSize: theme.tsXSmall,
        labelLineHeight: theme.tlXSmall,
        labelPaddingRight: '0',
        labelPaddingLeft: '0',
        labelOverflow: 'visible',

        idleColor: theme.tFilled,
        idlePlaceholder: theme.tHint,
        idleLabelColor: theme.tLabel,
        idleBorderColor: theme.elDivider,
        idleBorderStyle: 'none none solid',
        idleBorderWidth: '1px',
        idleBorderTransform: 'scale(0)',
        idleBorderRadius: '0',
        idleBackground: 'transparent',
        idleBoxShadow: 'none',
        idleOutline: 'none',

        focusColor: theme.tActive,
        focusPlaceholder: theme.tPlaceholder,
        focusLabelColor: theme.tAccent,
        focusBorderColor: theme.elAccent,
        focusBorderStyle: 'none none solid',
        focusBorderWidth: '2px',
        focusBorderTransform: 'scaleX(1)',
        focusBorderRadius: '0',
        focusBackground: 'transparent',
        focusBoxShadow: 'none',
        focusOutline: 'none',

        hoverColor: theme.tFilled,
        hoverPlaceholder: theme.tHint,
        hoverLabelColor: theme.tLabel,
        hoverBorderColor: theme.elSecondary,
        hoverBorderStyle: 'none none solid',
        hoverBorderWidth: '2px',
        hoverBorderTransform: 'scaleX(1)',
        hoverBorderRadius: '0',
        hoverBackground: 'transparent',
        hoverBoxShadow: 'none',
        hoverOutline: 'none',

        disabledColor: theme.tDisabled,
        disabledLabelColor: theme.tLabel,
        disabledPlaceholder: theme.tPlaceholder,
        disabledBorderTransform: 'scaleX(1)',
        disabledBorderStyle: 'none none dotted',
        disabledBorderWidth: '2px',
        disabledBorderColor: theme.elDivider,
        disabledBorderRadius: '0',
        disabledBackground: 'transparent',
        disabledBoxShadow: 'none',
        disabledOutline: 'none',

        errorColor: theme.tFilled,
        errorLabelColor: theme.tError,
        errorPlaceholder: theme.tHint,
        errorBorderColor: theme.elError,
        errorBorderStyle: 'none none solid',
        errorBorderWidth: '2px',
        errorBorderTransform: 'scaleX(1)',
        errorBorderRadius: '0',
        errorBackground: 'transparent',
        errorBoxShadow: 'none',
        errorOutline: 'none'
    };
};